import {IMuWidget} from "./IMuWidget";
import {NotifyCL} from "./generated/NotifyCL";
import {DateTimeString} from "./Types";

export class UiNotify extends IMuWidget
{
	public clUrl: string;
	protected cl: NotifyCL;
	public typeOpts: Record<string, {name: string, icon: string}>;
	private reloadInterval: number = 300000;
	public filter: {
		type: string[],
	}
	private lastNotifyId: number | null = null;

	beforeIndex() {
		this.muAppendContent(`<span class="simple-loader" mu-id="loader"></span> Upozornění
			<div class="notify__badgets" mu-id="badgets" mu-bind="badgets:@foreach">
				<span mu-bind='count|tern("notify__badget--active","")|prepend("notify__badget "):className' mu-template="budgetItem" mu-widget=".">
					<span mu-id="icon" mu-bind='icon|prepend("icon-"):className' class="icon-comment"></span> 
					<span mu-id="count" mu-bind="count">10</span>
				</span>
			</div>
			<div mu-id="sidebar" class="notify__sidebar">
				<div class="notify__sidebar__filters">
					<div mu-id="filterType" class="checkbox">
						<label mu-widget="." mu-template="filterTypeItem">
							<input type="checkbox" mu-id="visible" checked="checked">
							<span mu-bind='icon|prepend("icon-"):className'></span>
							<span mu-bind="name"></span>
						</label>
					</div>
				</div>
				<div mu-bind="items:@foreach" class="notify__sidebar__items" mu-id="items">
					<div class="notify__sidebar-item" mu-widget="UiNotifyItem" mu-template="itemItem">
						<div class="display-flex gap-4px em">
							<span class="notify__sidebar-item--icon" mu-id="icon"></span>
							<span class="notify__sidebar-item--dtAdd" mu-bind='dtAdd|dateTime("d.m.Y H:i")'></span>
							<span class="notify__sidebar-item--accountName flex-grow-1" mu-bind="accountName"></span>
							<span class="notify__sidebar-item--accountOrgDivisionCode" mu-bind="accountOrgDivisionCode"></span>
						</div>
						<div class="notify__sidebar-item--subject" mu-bind="subject"></div>
						<div class="notify__sidebar-item--messageShort" mu-bind="messageShort"></div>
						<div class="display-flex- strong">
							<span class="notify__sidebar-item--evidenceUid" mu-bind="evidenceUid"></span>
							<span class="notify__sidebar-item--summary flex-grow-1" mu-bind="summary"></span>
						</div>
					</div>				
				</div>
			</div>`);
	}
	badgets_click() {
		this.toggleSidebar();
	}

	private toggleSidebar() {
		this.ui.sidebar.classList.toggle('notify__sidebar--open');
		if (this.ui.sidebar.classList.contains('notify__sidebar--open') && this.lastNotifyId) {
			this.cl.markAsViewed(this.lastNotifyId).then(() => {

			});
		}
	}

	async afterIndex() { // return;
		if (!this.filter) this.filter = {
			type: Object.keys(this.typeOpts)
		}
		this.cl = new NotifyCL(this.clUrl);
		this.cl.onLoading = () => this.ui.loader.classList.toggle('simple-loader--loading', true);
		this.cl.onLoaded = () => this.ui.loader.classList.toggle('simple-loader--loading', false);
		for(const k in this.typeOpts)
		{
			const tfi = this.muWidgetFromTemplate('filterTypeItem', 'filterType', {
				visible_change: () => {
					this.filterItems();
					this.saveFilters();
				},
				type: k
			})
			tfi.muBindData(this.typeOpts[k]);
			tfi.ui.visible.checked = this.filter.type.includes(k);
		}

		this.reloadNotifies();
		setInterval(() => this.reloadNotifies(), this.reloadInterval)
	}

	protected lastBadgets: string = null;

	protected async reloadNotifies() {
		if (await this.bindBadgets())
			await this.bindList();
	}

	private async bindBadgets() {
		const cb = await this.cl.getNotifyCounts();
		const cbs = JSON.stringify(cb);
		if (cbs !== this.lastBadgets) {
			this.muBindData({
				badgets: cb
			});
			this.lastBadgets = cbs;
			this.lastNotifyId = Math.max(...cb.map(item => item.lastId));
			return true;
		}
		return false;
	}

	private async bindList() {
		this.muBindData({
			items: await this.cl.getNotifies(null, false,100)
		});
		this.filterItems();
	}

	private getFilterTypes(): string[] {
		const visibleTypes = [];
		for(const fti of this.muGetChildWidgets<IMuWidget>('filterType')) {
			if (fti.ui.visible.checked) { // @ts-ignore
				visibleTypes.push(fti.type);
			}
		}
		return visibleTypes;
	}

	private filterItems() {
		const visibleTypes = this.getFilterTypes();

		for(const item of this.muGetChildWidgets<UiNotifyItem>('items')) {
			item.muVisible(visibleTypes.includes(item.item.type), '.');
		}
	}

	private saveFilters() {
		this.filter.type = this.getFilterTypes();
		this.cl.saveFilter(this.filter);
	}
}

export class UiNotifyItem extends IMuWidget {
	muParent: UiNotify;
	item: NotifyItem;
	protected muAfterBindData(data: NotifyItem) {
		this.ui.icon.className = "icon-" + this.muParent.typeOpts[data.type].icon;
		this.ui.icon.title = this.muParent.typeOpts[data.type].name;
		this.item = data;
		this.container.classList.toggle('notify__sidebar-item--is-new', !data.dtDesktop);
	}

	container_click(ev: PointerEvent) {
		this.openLink(ev);
	}

	container_auxclick(ev: PointerEvent) {
		this.openLink(true);
	}

	private openLink(inNew: boolean | PointerEvent = false) {
		if (inNew instanceof PointerEvent) {
			inNew = inNew.ctrlKey;
		}
		if (inNew) window.open(this.item.url);
		else document.location.href = this.item.url;
	}
}

export type NotifyType = 'comment'|'change';

export  type NotifySum = {
	type: NotifyType,
	sum: number,
	lastId: number,
}

export type NotifyItem =  {
	type: NotifyType,
	id: number;
	accountId: number;
	dtAdd: DateTimeString;
	dtEmail?: DateTimeString;
	dtDesktop?: DateTimeString;
	ticketHistoryId?: any;
	subject: string;
	message: string;
	ticketId: number;
	operation: any;
	stateChanged?: any;
	url: string;
}